// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"13.2\" height=\"21.2\" viewBox=\"0 0 13.2 21.2\"><defs><style>.a{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:1.2px}</style></defs><path class=\"a\" d=\"M6,12.714,10.105,2h6.184L12.184,9.143H18L6.711,22l3.421-9.286Z\" transform=\"translate(-5.4 -1.4)\"/></svg>";
// Exports
module.exports = code;